<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      show-save-button
      unit="分量盘点单"
      edit-title
      id-key="commentId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.list"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <el-input
                v-model="data.DocNo"
                placeholder="请输入单据编号"
                v-if="noEdit"
              ></el-input>
              <span v-else>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                size="mini"
                v-model="data.DocDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="盘点仓库" prop="WarehouseId">
              <el-select
                size="mini"
                v-model="data.WarehouseId"
                placeholder="请选择"
              >
              <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="盘点人员" prop="EmpName">
              <el-input v-model="data.EmpName" @focus="addEmp" readonly></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="账面日期" prop="BookDate">
              <el-date-picker
                size="mini"
                v-model="data.BookDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" />
        </el-row>
      </template>
    </common-dialog>
    <!-- <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" /> -->
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import empDialog from "@/components/sales/business/empDialog";
import dialogList from "./dialogPartlist";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    // empDialog,
    dialogList
  },
  data() {
    return {
      data: {
        DocId: 0,
        InventoryDocId: 0,
        DocType: 0,
        DocNo: "",
        DocDate: "",
        WarehouseId: null,
        // EmpId: 0,
        BookDate: "",
        Status: 0,
        // EmpName: ""
      },
      noEdit: false,
      canExa: false,
      wareList: [],
      api: require("@/api/stock/inventory").default,
      billApi: require("@/api/sy/bill").default,
      rules: {
        WarehouseId: [{ required: true, message: "盘点仓库不能为空" }],
        // EmpName: [{ required: true, message: "盘点人员不能为空" }],
      },
      initTableData:[{
         T: 0,
            DocGoodsId: 0,
            DocId:0,
            BarCode:"",
            GoodsId:0,
            GoodsName:"",
            Model:"",
            UnitId: 0,
            UnitName:"",
            MultiUnit:false,
            Quantity:  0,
            BatchNo:"",
            Offer:0,
            Remark: "",
            ReferenceCost: 0,
            InventoryQuantity:  0,
            DiffQuantity: 0,
            Thumbnail:"",
            AddTime: "",
      }]
    };
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    if(!this.data.DocDate) {
      this.data.DocDate = today
      this.data.BookDate = today
    }
  },
  methods: {
    // addEmp() {
    //   this.$refs.empDialog.open().then((that) => {
    //     that.getData({ Status: 1 });
    //   });
    // },
    // setEmp(e) {
    //   this.data.EmpId = e.EmpId
    //   this.data.EmpName = e.EmpName
    // },
    onCreateOpened() {
      this.canExa = false
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.$refs.dialogList.tableData = JSON.parse(JSON.stringify(this.initTableData))
      this.$refs.dialogList.tableDel = []
      this.billApi.getDefaultSerialNo("分量盘点单").then(res => {
        if(res.Code==0&&res.Data) {
          this.data.DocNo = res.Data
        } else if(res.Code==0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onEditOpened() {

    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      let tb = []
      if(tableData.length==0 || !tableData.some(v=>v.GoodsId)) {
        this.$message.error("请填写商品列表");
        return false;
      }
      for(var i = 0; i < tableData.length; i++) {
        if(tableData[i].GoodsId){
        if(!tableData[i].Quantity) {
          this.$message.error("请填写盘点数量");
          return false;
        }
        if(tableData[i].T===0||tableData[i].T===1) {
          tb.push(tableData[i])
        }
        }
      }
      this.data.Goods = tb.concat(tableDel)
      return true
    },
  },
};
</script>